import { Injectable } from '@angular/core';
import { PanAppState } from '@panamax/app-state';
import { BehaviorSubject, Observable } from 'rxjs';
import { FEATURES } from '@shared/constants/splitio-features';
import {
  GUEST_LANDING_PAGE_VARIANT_B,
  GUEST_LANDING_PAGE_VARIANT_A,
} from '@shared/constants/merchandising-constants';
import { ProductAnalyticsService } from '@usf/ngrx-product';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GuestPageService {
  private splitDynamicGuestAbTestEnabledSubject = new BehaviorSubject<boolean>(
    false,
  );

  public splitDynamicGuestAbTestEnabled$: Observable<boolean> =
    this.splitDynamicGuestAbTestEnabledSubject.asObservable();

  becomeACustomerUrl: string = environment.becomeACustomer;

  constructor(
    private panAppState: PanAppState,
    private analyticsService: ProductAnalyticsService,
  ) {
    this.loadSplitDynamicGuestAbTestFlag();
  }

  private async loadSplitDynamicGuestAbTestFlag(): Promise<void> {
    try {
      const isEnabled = await this.panAppState.featureEnabled(
        FEATURES.split_dynamic_guest_ab_test.name,
      );
      this.splitDynamicGuestAbTestEnabledSubject.next(isEnabled);
    } catch (error) {
      this.splitDynamicGuestAbTestEnabledSubject.next(false);
    }
  }

  public getSplitDynamicGuestAbTestEnabledSnapshot(): boolean {
    return this.splitDynamicGuestAbTestEnabledSubject.getValue();
  }

  public trackBecomeACustomerButtonClickAndRedirect(): void {
    const splitDynamicGuestAbTestEnabled =
      this.getSplitDynamicGuestAbTestEnabledSnapshot();

    const variantValue = splitDynamicGuestAbTestEnabled
      ? GUEST_LANDING_PAGE_VARIANT_B
      : GUEST_LANDING_PAGE_VARIANT_A;

    this.analyticsService.trackBecomeACustomerButtonClick(variantValue);

    const separator = this.becomeACustomerUrl.includes('?') ? '&' : '?';
    const urlWithVariant = `${this.becomeACustomerUrl}${separator}variant=guest_${variantValue.toLowerCase()}`;

    window.open(urlWithVariant, '_self');
  }
}
